import type {
  PatchAdminV1StoresStoreIdPrivacyRequestsIdBodyStatus,
  PrivacyRequest,
  PrivacyRequestStatus,
} from '@nucleus-commerce/api-client/admin';
import { ApiError } from '@nucleus-commerce/api-client/transport';

export type PrivacyRequestMove = PatchAdminV1StoresStoreIdPrivacyRequestsIdBodyStatus;

// Same table as the backend's privacy service; anything else answers 409 with meta.allowed.
const NEXT: Record<PrivacyRequestStatus, readonly PrivacyRequestMove[]> = {
  received: ['in_progress', 'completed', 'rejected'],
  in_progress: ['completed', 'rejected'],
  completed: [],
  rejected: [],
};

export function nextStatuses(status: PrivacyRequestStatus): readonly PrivacyRequestMove[] {
  return NEXT[status];
}

/** The bundle exists once an export request completed for a customer that still existed. */
export function canDownloadExport(request: Pick<PrivacyRequest, 'kind' | 'exportReady'>): boolean {
  return request.kind === 'export' && request.exportReady;
}

/** Moves the backend said it would allow instead, from a 409's `meta.allowed`. */
export function allowedFromConflict(error: unknown): PrivacyRequestMove[] | null {
  if (!(error instanceof ApiError) || error.kind !== 'conflict') return null;
  const allowed = error.meta.allowed;
  return Array.isArray(allowed)
    ? allowed.filter((value): value is PrivacyRequestMove => typeof value === 'string')
    : null;
}
